export default "__VITE_ASSET__$TYj2uBR__"